import React from 'react';
import { X, AlertTriangle } from 'lucide-react';

interface ConfirmDialogProps {
  title?: string;
  message: string;
  onYes: () => void;
  onNo?: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  title = 'Are you sure?',
  message,
  onYes,
  onNo,
  onCancel
}) => {
  return (
    <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center">
      <div className="bg-[#20232a] text-white rounded-2xl shadow-[0_10px_30px_rgba(0,0,0,0.6)] w-full max-w-sm p-6 relative text-sm border border-neutral-700">
        <button
          onClick={onCancel}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-200"
        >
          <X className="w-4 h-4" />
        </button>

        <div className="flex items-center gap-2 mb-4">
          <AlertTriangle className="text-yellow-400 w-5 h-5" />
          <h3 className="text-base font-semibold">{title}</h3>
        </div>

        <p className="text-gray-300 mb-6">{message}</p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onYes}
            className="bg-red-600 hover:bg-red-700 text-white px-4 py-1.5 rounded text-xs"
          >
            Yes
          </button>
          {onNo && (
            <button
              onClick={onNo}
              className="bg-neutral-700 hover:bg-neutral-600 text-gray-200 px-4 py-1.5 rounded text-xs"
            >
              No
            </button>
          )}
          <button
            onClick={onCancel}
            className="bg-neutral-800 hover:bg-neutral-700 text-gray-300 px-4 py-1.5 rounded text-xs"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;
